import styled from 'styled-components';

const ExploreSection = styled.section`
  position: relative;
`;

export default ExploreSection;
